import { render, staticRenderFns } from "./MapIndex.vue?vue&type=template&id=354c933f&scoped=true"
import script from "./MapIndex.vue?vue&type=script&lang=js"
export * from "./MapIndex.vue?vue&type=script&lang=js"
import style0 from "./MapIndex.vue?vue&type=style&index=0&id=354c933f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c933f",
  null
  
)

export default component.exports